meedy.controller('meedy.doctorEditController', ['$scope', '$state', '$stateParams', '$mdToast', '$mdDialog', '$translate',
    'meedy.objectHelper', 'applicationModel', 'meedy.userModel', 'meedy.resourceDetailsModel', 'meedy.dictionaryModel',
    'meedy.specializationModel', 'meedy.priceListModel', 'meedy.availabilityRuleModel', 'Upload', '$timeout',
    function ($scope, $state, $stateParams, $mdToast, $mdDialog, $translate, objectHelper, applicationModel, userModel,
              resourceDetailsModel, dictionaryModel, specializationModel, priceListModel, availabilityRuleModel, Upload,
              $timeout) {

        var listeners = {};

        function setData() {
            $scope.wrapper = new ResourceMeedyVO();

            $scope.forms = {
                editDoctor: null
            };

            $scope.phoneRegExp = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{3})/;
            $scope.wwwRegExp = /^[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
            $scope.phoneRegExp = '^\\d+$';

            $scope.croppedPictureData = '';
            $scope.savingInProgress = false;
            $scope.academicTitleList = [];

            $scope.hideAddButton();
            $scope.hideBackButton();
            $scope.resetTitle();

            $scope.ageList = [
                {
                    value: 0,
                    label: $scope.T('T.MEEDY.MODULE.MY_DATA.UNDER') + ' 1 ' + $scope.T('T.MEEDY.MODULE.MY_DATA.YEAR')
                },
                {value: 1, label: '1 ' + $scope.T('T.MEEDY.MODULE.MY_DATA.YEAR')}
            ];
            for (var i = 2; i < 19; i++) {
                $scope.ageList.push({value: i, label: i + ' ' + $scope.T('T.MEEDY.MODULE.MY_DATA.YEARS')});
            }

            $scope.minutes = availabilityRuleModel.generateAppointmentTimeOptions(null, 5, "min");
            $scope.availableLengths = availabilityRuleModel.generateAppointmentTimeOptions(null, 5, "min");

            $scope.mainSpecializationList = [];
            $scope.specializationList = [];
            $scope.specializationFields = ['firstSpecialization', 'secondSpecialization', 'thirdSpecialization', 'fourthSpecialization'];
        }

        function setPermissions() {
            $scope.isPhysician = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.PHYSICIAN;
            $scope.isReceptionist = userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.MEDICAL_RECEPTIONIST
                || userModel.currentUser.partnerType === Enum.MEEDY.USER_PARTNER_TYPE.RECEPTIONIST;
        }

        function setListeners() {
            $scope.$on(Event.MEEDY.DICTIONARY.GET_ACADEMIC_TITLES.SUCCESS, function (event, dataPage) {
                for (var i = 0; i < dataPage.data.length; i++) {
                    $scope.academicTitleList.push(dataPage.data[i].name);
                }
            });

            $scope.$watch('wrapper.firstSpecialization', function (newValue, oldValue) {
                if (newValue) {
                    $scope.evaluatePwzRequirement();
                }
            });

            $scope.$watch('wrapper.secondSpecialization', function (newValue, oldValue) {
                if (newValue) {
                    $scope.evaluatePwzRequirement();
                }
            });

            $scope.$watch('wrapper.thirdSpecialization', function (newValue, oldValue) {
                if (newValue) {
                    $scope.evaluatePwzRequirement();
                }
            });

            $scope.$watch('wrapper.fourthSpecialization', function (newValue, oldValue) {
                if (newValue) {
                    $scope.evaluatePwzRequirement();
                }
            });

            $scope.$on(Event.MEEDY.USER.PWZ_EXISTENCE.SUCCESS, function (event, answer) {
                $scope.duplicatedPwz = answer.exists;
                $scope.forms.editDoctor["pwz"].$validate();
            });

            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });

            listeners.onSpecializationsLoad = function (data) {
                $scope.specializationList = data;
            };

            listeners.onMainSpecializationsLoad = function (data) {
                $scope.mainSpecializationList = data;
            };

            listeners.onDoctorDataLoad = function (data) {
                $scope.wrapper = angular.copy(data);

                $scope.wrapper.specializationResources.forEach(function (specializationResource) {
                    $timeout(function() {
                        var _spec = angular.copy(specializationResource);
                        _spec.specialization.childrens = _spec.specialization.childrens || !!(_spec.acceptsAgeTo || _spec.acceptsAgeFrom);
                        $scope.wrapper[$scope.specializationFields[specializationResource.order]] = _spec;
                    });
                })
            }
        }

        function setActions() {
            $scope.uploadPicture = function (pictureData, pictureName) {
                var croppedFile = Upload.dataUrltoBlob(pictureData, pictureName);
                userModel.uploadDoctorPicture(croppedFile, $scope.wrapper.id).then(function() {
                    $scope.refreshingDataAfterPictureUpload = true;
                    $scope.pictureFile = null;
                    $scope.croppedPictureData = '';

                    $state.go(Constant.STATE.APP.MEEDY.SETTINGS.DOCTOR.LIST);
                });
            };

            $scope.deletePicture = function () {
                userModel.deleteOfficePicture($scope.wrapper.id);

                var successWatcherDisabler = $scope.$on(Event.MEEDY.USER.DELETE_MY_PICTURE.SUCCESS, function (event, result) {
                    successWatcherDisabler();
                    errorWatcherDisabler();

                    $scope.refreshingDataAfterPictureUpload = true;
                    resourceDetailsModel.getById($stateParams.id);
                });

                var errorWatcherDisabler = $scope.$on(Event.MEEDY.USER.DELETE_MY_PICTURE.ERROR, function (event, error) {
                    successWatcherDisabler();
                    errorWatcherDisabler();
                });
            };

            $scope.validatePwz = function () {
                if ($scope.wrapper.pwz) {
                    userModel.pwzExistence($scope.wrapper.pwz);
                }
            };

            $scope.evaluatePwzRequirement = function () {
                var wrapper = $scope.wrapper;
                if (wrapper) {
                    var firstSpecialization = firstSpecialization;
                    var secondSpecialization = secondSpecialization;
                    $scope.pwzRequired = (firstSpecialization && firstSpecialization.pwzRequired)
                        || (secondSpecialization && secondSpecialization.pwzRequired);
                }
            };

            $scope.save = function () {
                $scope.forms.editDoctor.$setSubmitted();
                if ($scope.forms.editDoctor.$valid) {
                    var requestWrapper = angular.copy($scope.wrapper);

                    requestWrapper.specializationResources = [];
                    $scope.specializationFields.forEach(function (field, idx) {
                        if (!!(requestWrapper[field] && requestWrapper[field].specialization)) {
                            requestWrapper[field].order = idx;
                            if(!requestWrapper[field].specialization.childrens) {
                                delete requestWrapper[field].acceptsAgeFrom;
                                delete requestWrapper[field].acceptsAgeTo;
                            }
                            requestWrapper.specializationResources.push(requestWrapper[field]);
                        }
                        delete requestWrapper[field];
                    });
                    resourceDetailsModel.saveOrUpdate(requestWrapper).then(function (data) {
                        if($scope.croppedPictureData && $scope.pictureFile) {
                            $scope.uploadPicture($scope.croppedPictureData, $scope.pictureFile.name, data);
                        } else {
                            $state.go(Constant.STATE.APP.MEEDY.SETTINGS.DOCTOR.LIST);
                        }
                    }, function () {

                    })
                }
            };

            $scope.getMatches = function(query) {
                var results = [];

                for(var i = 0; i < $scope.academicTitleList.length; i++) {
                    if($scope.academicTitleList[i].indexOf(query) > -1) {
                        results.push($scope.academicTitleList[i]);
                    }
                }

                return results;
            };
        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.MEEDY.SETTINGS.MY_DATA);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MEEDY.UI.APPLICATION.EDIT_OFFICE');
        }

        function initialize() {
            specializationModel.specializationsFromMedicalPost().then(listeners.onMainSpecializationsLoad);
            specializationModel.getSpecializations().then(listeners.onSpecializationsLoad);
            dictionaryModel.getAcademicTitles();
            resourceDetailsModel.getById($stateParams.id).then(listeners.onDoctorDataLoad);
            applicationModel.viewReady = true;
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
